import { Injectable } from '@angular/core';
import { Creds, GoogleIdentityService } from 'bish-apps-common';
import { SettingsClient } from './protogen/settings/ServiceServiceClientPb';
import { GetSessionTokenRequest, GetSessionTokenResponse } from './protogen/settings/service_pb';
import { SERVER } from './defaults';

const settingsClient: SettingsClient = new SettingsClient(SERVER);

/**
 * Wraps a GoogleAuthenticator into an Angular singleton service.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private authenticator: GoogleIdentityService;
  private creds?: Creds;

  constructor() {
    const signInDiv = document.getElementById('google-sign-in');
    if (!signInDiv) {
      throw 'Could not find google-sign-in div';
    }
    this.authenticator = new GoogleIdentityService(signInDiv as HTMLDivElement);
  }

  /**
   * @returns The cached OAuth2 credentials, or waits for either the user to sign in or
   *     the google signin library to authenticate.
   */
  async getCreds(): Promise<Creds> {
    if (!this.creds) {
      const creds = await this.authenticator.authenticateOrWaitForSignIn();
      if (!creds.id_token) {
        throw `No id_token during authentication.`;
      }

      // Exchange the short-lived id_token for a bish session token that does not expire.
      this.creds = await new Promise((resolve, reject) => {
        const req = new GetSessionTokenRequest().setIdToken(creds.id_token);
        settingsClient.getSessionToken(req, {}).then((response: GetSessionTokenResponse) => {
          creds.session_token = response.getSessionToken();
          resolve(creds);
        }, (err: Error) => reject(err));
      });
    }

    return this.creds as Creds;
  }

  /**
   * Refreshes the authentication token.
   * @deprecated
   */
  async refresh(): Promise<Creds> {
    this.creds = await this.authenticator.refresh();
    return this.creds;
  }
}
